import React from "react";
import { Box, Paper, Typography } from "@mui/material";

import MapOverlay from "fond/map/MapOverlay";

interface MapModeBannerProps {
  title: string;
  hint: string;
  /** Buttons shown beside the title. */
  children: React.ReactNode;
}

/**
 * Floating map bar with a title and actions, and a hint along the bottom of the map.
 */
const MapModeBanner: React.FC<MapModeBannerProps> = ({ title, hint, children }) => (
  <MapOverlay showOverlay={false} centerContent={false}>
    <Paper
      elevation={3}
      role="toolbar"
      aria-label={title}
      sx={{
        position: "absolute",
        top: 12,
        left: "50%",
        transform: "translateX(-50%)",
        display: "flex",
        alignItems: "center",
        gap: 0.75,
        py: 0.75,
        pr: 0.75,
        pl: 1.75,
      }}
    >
      <Typography fontWeight={500} mr={0.75} noWrap>
        {title}
      </Typography>
      {children}
    </Paper>
    <Box
      sx={{
        position: "absolute",
        bottom: 40,
        left: "50%",
        transform: "translateX(-50%)",
        py: 1,
        px: 1.75,
        borderRadius: 1,
        bgcolor: "grey.900",
        color: "common.white",
      }}
    >
      <Typography variant="body2" noWrap>
        {hint}
      </Typography>
    </Box>
  </MapOverlay>
);

export default MapModeBanner;
